import type { ChipVariant } from '@/components/ui'
import type { OnboardingStatus } from '../api/onboarding-types'
import type { VendorRequestStatus } from '../api/vendor-request-types'

export const STATUS_LABEL: Record<OnboardingStatus, string> = {
  awaiting_vendor: 'Awaiting vendor',
  draft: 'Draft',
  regulatory_review: 'Regulatory review',
  commercial_review: 'Operations review',
  approved: 'Approved',
  pushed_to_odoo: 'In Odoo',
  push_failed: 'Push failed',
  cancelled: 'Cancelled',
}

export const STATUS_VARIANT: Record<OnboardingStatus, ChipVariant> = {
  awaiting_vendor: 'neutral',
  draft: 'neutral',
  regulatory_review: 'info',
  commercial_review: 'info',
  approved: 'success',
  pushed_to_odoo: 'success',
  push_failed: 'danger',
  cancelled: 'neutral',
}

/** Mirrors middleware app/services/product_onboarding.py role tuples. */
export const EDIT_ROLES = ['admin', 'operations', 'operations_logistics', 'purchasing'] as const
/** Regulatory sign-off is regulatory-role only (Chris 2026-10-11: "Regulatory always has to sign off"). */
export const REGULATORY_SIGN_ROLES = ['regulatory'] as const
/** The second approval, shown as "Operations sign-off" (renamed from Commercial, Chris 2026-10-11). */
export const COMMERCIAL_SIGN_ROLES = ['admin', 'purchasing', 'operations', 'operations_logistics'] as const
/** Who may change a request's content: ops roles plus regulatory (Chris 2026-10-11). */
export const FIELD_EDIT_ROLES = [...EDIT_ROLES, 'regulatory'] as const

export const CHECKLIST_GROUPS: { key: string; label: string }[] = [
  { key: 'identity', label: 'Identity' },
  { key: 'units', label: 'Units & pack' },
  { key: 'vendor', label: 'Vendor' },
  { key: 'regulatory', label: 'Regulatory data' },
  { key: 'pricing', label: 'Pricing' },
  { key: 'documents', label: 'Documents' },
  { key: 'crosscheck', label: 'Document cross-check' },
]

export const INCOTERMS = ['EXW', 'FCA', 'FOB', 'CFR', 'CIF', 'CPT', 'CIP', 'DAP', 'DPU', 'DDP'] as const

export const VENDOR_STATUS_LABEL: Record<VendorRequestStatus, string> = {
  open: 'Waiting for vendor',
  vendor_submitted: 'Submitted',
  imported: 'Imported',
  revoked: 'Cancelled',
}

export const VENDOR_STATUS_VARIANT: Record<VendorRequestStatus, ChipVariant> = {
  open: 'info',
  vendor_submitted: 'warning',
  imported: 'success',
  revoked: 'neutral',
}
